import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './Keycloak';


ReactDOM.render(
    <BrowserRouter>
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{ onLoad: 'check-sso' }}
            autoRefreshToken={false}
        >
            <Provider store={store}>
                <App />
            </Provider>
        </ReactKeycloakProvider>
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
